import { GrnItemsInfo } from "./grn-items-info.model";

export class GrnDto {
  grnId?: number;
  grnDate: any;
  InvoiceDate: any;
  grnNumber?: string;
  invoiceNumber: string;
  poId: number;
  unitId: number;
  saleOrderId: number;
  totalQuantity?: number;
  totalDiscount: number;
  totalTax: number;
  totalCost: number;
  remarks: string;
  approvar?: string;
  status?: string;
  referenceNumber?: number;
  createdUser : string;
  updatedUser ?: string;
  vendorId : number;
  grnItemsInfo: GrnItemsInfo[];
  locationId?: number;

    /**
    * @param grnId
  * @param grnDate
  * @param InvoiceDate
  * @param grnNumber?
  * @param invoiceNumber
  * @param poId
  * @param saleOrderId
  * @param totalQuantity
  * @param totalDiscount
  * @param totalTax
  * @param totalCost
  * @param remarks
  * @param approvar
  * @param status
  * @param referenceNumber
  * @param createdAt 
  * @param createdUser 
  * @param updatedAt 
  * @param updatedUser 
  * @param versionFlag 
  * @param grnItemsInfo
  * @param vendorId
  * @param unitId
     */
    constructor(grnId: number,grnDate: any,InvoiceDate: any,grnNumber: string,invoiceNumber: string,poId: number,unitId:number,saleOrderId:number,totalQuantity: number,totalDiscount: number,totalTax: number,totalCost: number,remarks: string,status: string,referenceNumber: number,createdUser : string,updatedUser : string,vendorId : number,grnItemsInfo: GrnItemsInfo[],approvar?: string,locationId?:number){
        this.grnId = grnId;
  this.grnDate = grnDate;
  this.InvoiceDate = InvoiceDate;
  this.grnNumber = grnNumber;
  this.invoiceNumber = invoiceNumber;
  this.poId = poId;
  this.unitId = unitId;
  this.saleOrderId = saleOrderId;
  this.totalQuantity = totalQuantity;
  this.totalDiscount = totalDiscount;
  this.totalTax = totalTax;
  this.totalCost = totalCost;
  this.remarks = remarks;
  this.approvar = approvar;
  this.status = status;
  this.referenceNumber = referenceNumber;
  this.createdUser  = createdUser;
  this.updatedUser  = updatedUser;
  this.vendorId  = vendorId;
  this.grnItemsInfo = grnItemsInfo;
  this.locationId = locationId;
       
    }
}
